import { useProductsQuery } from './useProductsQuery'

export const useHardcodedRecommendations = ({ enabled }: { enabled: boolean }) => {
  const { productsQuery } = useProductsQuery(
    [
      {
        libraryId: [
          'lib_bcf541b4ca744d09ae', // White Glossy Mud
          'lib_e8c348ae25d2455385',
          'lib_7acfd8f1471e4f98b7',
          'lib_501ea4cf102f4d3695',
          'lib_0337b18b3613451ca5',
        ],
      },
    ],
    {
      staleTime: Infinity,
      enabled,
    },
  )

  return { hardcodedProductsQuery: productsQuery }
}
